import React, { useState } from "react";

import VisibilitySensor from "react-visibility-sensor";
import { useTranslation } from "react-i18next";


function FleetOne() {

  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={500}>

    <div id="Fleet-structure-truck">
      <div className="container">
        <h1 className={`${isVisible ? "visible" : ""}`}>
          <span>{t("fleet_one_title_span")}</span> {t("fleet_one_title")}
        </h1>
        <p className={`mt-4 ${isVisible ? "visible" : ""}`}>
          {t("fleet_one_text")}
        </p>
      </div>
      <div class="sketchfab-embed-wrapper">
        <iframe
          className={`${isVisible ? "visible" : ""}`}
          title="GH Solucionador Logístico"
          frameborder="0"
          allowfullscreen
          mozallowfullscreen="true"s
          webkitallowfullscreen="true"
          allow="autoplay; fullscreen; xr-spatial-tracking"
          xr-spatial-tracking
          execution-while-out-of-viewport
          execution-while-not-rendered
          web-share
          src="https://sketchfab.com/models/d7f73afd3d6e4d0d9ceb8b6dbc1bfcd2/embed?autostart=1"
          style={{
            width: "100%",
            height: "550px",
          }}
        ></iframe>
      </div>
    </div>
    </VisibilitySensor>
  );
}

export default FleetOne;
